import { render, staticRenderFns } from "./forgetpassword.vue?vue&type=template&id=61532edc&scoped=true&"
import script from "./forgetpassword.vue?vue&type=script&lang=js&"
export * from "./forgetpassword.vue?vue&type=script&lang=js&"
import style0 from "./forgetpassword.vue?vue&type=style&index=0&id=61532edc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61532edc",
  null
  
)

export default component.exports